import Edit from '../../../base/forms/user/Edit';

const edit: Edit = {
  header: 'Detail uživatele',
  submit: 'Upravit'
};

export default edit;
